export default __webpack_public_path__ + "static/media/slide2.05fcff5d.jpg";